import classNames from "classnames";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  isDisable?: boolean;
}

export const NavRightArrowOnbForm = ({
  theme,
  style,
  onClick,
  isDisable,
}: IProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames({ [`${style}`]: true }, "arrow-onb-form")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="20"
        viewBox="0 0 12 20"
        fill="none"
      >
        <path
          d="M11.9752 9.99943L-0.0100979 0.510698L0.048827 19.5621L11.9752 9.99943Z"
          fill="#333333"
        />
      </svg>
    </div>
  );
};
